import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';

// Layout components
import Header from '@layout/Header';
import Footer from '@layout/Footer';
import LoadingSpinner from '@ui/LoadingSpinner';

// Lazy load pages for better performance
// const Home = React.lazy(() => import('@home/Home'));
// const Mint = React.lazy(() => import('@mint/Mint'));
// const Buy = React.lazy(() => import('@pages/Buy'));
// const MyPage = React.lazy(() => import('@pages/MyPage'));
// const Faqs = React.lazy(() => import('@pages/Faqs'));
// const Audits = React.lazy(() => import('@pages/Audits'));
// const History = React.lazy(() => import('@pages/History'));
// const Widget = React.lazy(() => import('@widgets/Widget'));

import Home from '@home/Home';
import Mint from '@mint/Mint';
import Buy from '@pages/Buy';
import MyPage from '@pages/MyPage';
import Faqs from '@pages/Faqs';
import Audits from '@pages/Audits';
import History from '@pages/History';
import Widget from '@widgets/Widget';

// Hooks
import { useAppContext } from '@context/AppContext';

// Components
import GlobalModal from '@ui/GlobalModal';

const App = () => {
  const { spinner, themeConfigLoading, isInitialized } = useAppContext();

  // Show general loading spinner for other operations
  if (!isInitialized || themeConfigLoading || spinner) {
    return <LoadingSpinner message={"Loading "} />;
  }

  return (
    <Routes>
      {/* Standalone widget route - no layout */}
      <Route path="/funds-raised/:type" element={<Widget />} />
      
      {/* Main app routes - with layout */}
      <Route path="/*" element={
        <Suspense fallback={<LoadingSpinner />}>
          <div className="app">
            <Header />      
            <main className="app__main">
              <Routes>
                <Route index element={<Home />} />
                <Route path="share" element={<Home />} />
                <Route path="my" element={<MyPage />} />
                <Route path="mint" element={<Mint />} />
                <Route path="buy" element={<Buy />} />
                <Route path="buy/:tokenId" element={<Buy />} />
                <Route path="faqs" element={<Faqs />} />
                <Route path="audit" element={<Audits />} />
                <Route path="history" element={<History />} />
                <Route path="*" element={<Home />} />
              </Routes>
            </main>      
            <Footer />
            <GlobalModal />
          </div>
        </Suspense>
      } />
    </Routes>
  );
};

export default App;
